<template lang="html">
  <d-form @submit.prevent="save" :validated="hasErrors">
    <d-form-row>

      <!-- Nome -->
      <d-col md="6" class="form-group">
        <label for="name">Nome</label>
        <d-form-input
          :state="hasErrorFiled('name')"
          type="text"
          id="name"
          placeholder="Nome"
          v-model="model.name"
        />
        <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
      </d-col>

      <!-- Unit Type Id -->
      <d-col md="3" class="form-group">
        <label for="fePrice">Unidade de medida</label>
        <d-select
          v-model="model.unit_type_id"
          :options="productUnits"
          value-field="id"
          text-field="name"
        >
        </d-select>
      </d-col>

      <!-- Price -->
      <d-col md="3" class="form-group">
        <label for="fePrice">Preço</label>
        <d-input-group prepend="R$">
          <input-currency
            model-index="price"
            placeholder="Total"
            :model="model"
          ></input-currency>
        </d-input-group>
      </d-col>

    </d-form-row>

  </d-form>
</template>

<script>
import { mapActions } from 'vuex';
import InputCurrency from '_shared/InputCurrency.vue';
import Loader from '_shared/Loader.vue';
import MaterialService from '_services/rest/modules/material';
import Events from '_utils/events';
import mixin from '_common/mixins/ValidateForm';
import { PRODUCT_UNITS_OPTIONS } from '_modules/product/components/ProductModel';
import { MODEL, _LOAD_MODEL_, _SAVE_MATERIAL_SUCCESS_ } from './MaterialModel';

export default {
  name: 'material-form',
  mixins: [mixin],
  components: {
    InputCurrency,
    Loader,
  },
  data() {
    return {
      model: { ...MODEL },
      loading: false,
      errors: {
        name: { required: false },
        price: { required: false },
        unit_type_id: { required: false },
      },
    };
  },
  computed: {
    productUnits() {
      const { productUnits } = this.$store.state.product;
      if (productUnits && productUnits.length) {
        return productUnits;
      }
      return PRODUCT_UNITS_OPTIONS;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getProductUnits',
    ]),

    getOptions() {
      if (!this.$store.state.material.productUnits) {
        this.setToggle({ type: 'progress', bool: true });
        this.getProductUnits()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          });
      }
    },
    save() {
      if (this.checkForm()) {
        MaterialService.save(this.model)
          .then(response => {
            this.success(response);
          })
          .catch(error => {
            this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
          });
      }
      return null;
    },
    success(materialSaved) {
      this.activeAlert({ message: 'Material salvo com sucesso', theme: 'success' });
      this.$store.commit('setMaterial', materialSaved);
      Events.$emit(_SAVE_MATERIAL_SUCCESS_, materialSaved);
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_, newValue => {
      this.model = { ...newValue };
    });
    this.getOptions();
  },
};
</script>

<style lang="scss" scoped>
</style>
